
<el-container class="screen-parameters screen-parameters-fullHeight services" v-loading="loading || loadingDelete">
  <div class="clients-panel cash-list">
    <div class="clients-panel-container">
      <el-row class="black-inputs">
        <div class="cash-header">
          <div class="nav-toggle" @click="showHideScreenCashList">
            <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
          </div>
        </div>
        <br>
        <el-row class="dateChooser" :gutter="5">
          <el-col :md="{ span: 8 }" :sm="{ span: 11 }" :xs="24">
            <el-date-picker class="datePicker" ref="picker" v-model="datesCash" :picker-options="pickerOptions"
              type="daterange" range-separator="-" start-placeholder="Date de début" end-placeholder="Date de fin"
              format="dd/MM/yyyy" />
          </el-col>
          <el-col :md="{ span: 4, offset: 0 }" :sm="{ span: 11, offset: 2 }" :xs="24">
            <el-select v-model="typeCash" placeholder="Type">
              <el-option label="Caution" value="caution"></el-option>
              <el-option label="Prépaiement" value="prepaiement"></el-option>
            </el-select>
          </el-col>
          <el-col :md="{ span: 4, offset: 0 }" :sm="{ span: 11 }" :xs="24">
            <el-select v-model="serviceCash" placeholder="Service">
              <el-option v-for="t in getAllServicesIdsAndName" :key="t" :label="t" :value="t">
              </el-option>
            </el-select>
          </el-col>
          <el-col :md="{ span: 4, offset: 0 }" :sm="{ span: 11, offset: 2 }" :xs="24">
            <el-input class="inputEuro" placeholder="Prix / couverts" v-model="priceCash"></el-input>
          </el-col>
          <el-col :md="{ span: 4, offset: 0 }" :sm="{ span: 11 }" :xs="24">
            <el-input class="inputCouv" placeholder="couverts min." v-model="nbCouv"></el-input>
          </el-col>
        </el-row>
        <el-row v-if="typeCash === 'caution'">
          <el-col :md="{ span: 4, offset: 0 }" :sm="{ span: 11 }" :xs="24">
            <el-time-select v-model="limitHour" :picker-options="{
              start: '00:00',
              step: '01:00',
              end: '72:00'
            }" :clearable="true" placeholder="Limite avant annulation">
            </el-time-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="{ span: 4, offset: 20 }" :xs="24" :sm="{ span: 12, offset: 12 }">
            <el-button type="primary" @click="createNewCashEntry()">Ajouter des dates</el-button>
          </el-col>
        </el-row>
      </el-row>
      <el-row class="black-inputs">
        <el-col :md="24" class="screen-clients">
          <el-table ref="multipleTable" :data="getCashList">
            <el-table-column prop="startDate" label="Début" sortable>
              <template slot-scope="scope">
                <span>{{ dateRenderer(scope.row.startDate) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="endDate" label="Fin" sortable>
              <template slot-scope="scope">
                <span>{{ dateRenderer(scope.row.endDate) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="service" label="Service" sortable>
            </el-table-column>
            <el-table-column prop="type" label="Type" sortable>
              <template slot-scope="scope">
                <span>{{ strUcFirst(scope.row.type) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="value" label="Prix" sortable>
              <template slot-scope="scope">
                <span>{{ scope.row.value }} €/c.</span>
              </template>
            </el-table-column>
            <el-table-column prop="nbCouv" label="Couverts min." sortable>
              <template slot-scope="scope">
                <span>{{ scope.row.nbCouv }} c.</span>
              </template>
            </el-table-column>
            <el-table-column prop="limitHour" label="Annulation" sortable>
              <template slot-scope="scope">
                <span>{{ scope.row.limitHour }}</span>
              </template>
            </el-table-column>
            <el-table-column label=" ">
              <template slot-scope="scope">
                <el-button class="dark" type="primary"
                  @click="editCashInfos(scope.row.startDate, scope.row.endDate, scope.row.service)">
                  <span class="mobile-show"><i class="el-icon-edit"></i></span>
                  <span class="mobile-hide">Modifier</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label=" ">
              <template slot-scope="scope">
                <el-popover placement="top" width="200" v-model="scope.row.popupValidDelete"
                  popper-class="popup-delete black-inputs">
                  <p>
                    Êtes vous sûr ?
                  </p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" class="dark" type="primary"
                      @click="scope.row.popupValidDelete = false">Annuler</el-button>
                    <el-button type="primary" size="mini"
                      @click="deleteCashInfos(scope.row.startDate, scope.row.endDate, scope.row.service)">Confirmer</el-button>
                  </div>
                  <el-button class="red" type="primary" slot="reference">
                    <span class="mobile-show"><i class="el-icon-delete"></i></span>
                    <span class="mobile-hide">Supprimer</span>
                  </el-button>
                </el-popover>
                <!-- <el-button class="red" type="primary" @click="deleteCashInfos(scope.row.startDate, scope.row.endDate, scope.row.service)">Supprimer</el-button> -->
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;margin-top: 30px;">
            <el-pagination background layout="prev, pager, next" :total="total" @current-change="current_change">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</el-container>
